<template lang="html">
    <div class="content">
        <div class="image image-brothers"></div>
        <p>
            De Vrijmetselarij vormt een methode waarin, aan de hand van bouw- en lichtsymboliek, voortdurend gestreefd wordt naar bewust&shy;wording en geestes-ont&shy;wikkeling.
        </p>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <p class="question">Wat betekent dat?</p>
                <p>
                    Alhoewel vaak geduid als een illuster gezelschap dat achter de schermen ‘aan de touwtjes trekt’, is de Vrijmetselarij feitelijk niets meer dan een vereniging van mannen, die samen, op basis van rede, weten&shy;schap en logica, en dus onafhankelijk van politieke of religieuze beweging, zelfstandig zoeken naar een zinvolle invulling van hun bestaan.
                </p>
            </div>
            <div class="f-1">
                <p class="concern">Met als doel?</p>
                <p>
                    Verbeter de wereld, begin bij jezelf! Een belangrijk credo binnen de vrijmetselarij is 'Op U komt het aan'.
                </p>
                <p>
                    Het zelfstandig opdoen van kennis, wijsheid en ervaring is een voortdurend proces, waarbij niet zozeer het ‘eindpunt’ maar juist het streven naar persoonlijke groei de drijfveer vormt.
                </p>
            </div>
        </div>
        <p class="quote">“Als je de tocht aanvaardt, wens dan dat de weg lang mag zijn.” <span class="author">~ K.P. Kavafis</span></p>
        <div class="image image-compass"></div>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <p class="question">
                    Individueel maar toch samen.
                </p>
                <p>
                    Vrijmetselaren geven elk een eigen invulling aan de inhoud van datgene wat ze ervaren. Arbeiden noemen we dat. Samen in kleine groepen (die loges genoemd worden) vergelijken we in een sfeer van respect en vertrouwen onze idee&euml;n en ervaringen met elkaar.
                </p>
                <p>
                    We leren daar bijvoorbeeld van dat het belangrijker is om te luisteren dan om altijd maar iedereen van ons eigen gelijk te willen overtuigen.
                </p>
                <p>
                    De leden van een loge ervaren vaak een hechte band en spreken elkaar aan met het woord 'broeder'.
                </p>
            </div>
            <div class="f-1">
                <p class="concern">
                    Hoe is dat anders dan een vriendengroep?
                </p>
                <p class="answer">
                    Vriendengroepen ontstaan vaak op basis van een ge&shy;deelde achtergrond of gezamenlijk interesse-gebied. Bij de Vrijmetselarij vind je juist allerlei hele ver&shy;schillende soorten mensen.
                </p>
                <p>
                    Jonge(re) broeders die net aan hun carriere begonnen zijn, broeders op middelbare leeftijd die van de hoed en de rand weten en broeders op leeftijd die (zo lijkt het soms) werkelijk alles gezien hebben en de andere broeders dikwijls met diepgaande inzichten be&shy;voor&shy;delen.
                </p>
            </div>
        </div>
        <p class="quote">“Hoe wordt de mens zichzelf?” <span class="author">~ S&oslash;ren Kierkegaard </span></p>
        <p class="question">
            Is dat alles?!
        </p>
        <p>
            Er is door de jaren heen ontzettend veel geschreven over de Vrijmetselarij. Ook op internet valt heel veel meer te vinden dan wij ooit op deze website zouden kunnen vermelden. Echter, zelfs als u al die boeken en artikelen nauw&shy;keurig uitgeplozen hebt.., dan nog rest de vraag; <span class="em">'wat betekent de Vrijmetselarij voor u?'</span>
        </p>
        <hr />
        <Proceedings></Proceedings>
    </div>
</template>

<script>

import Proceedings from './Proceedings'

export default {
    name: 'Vrijmetselarij',
    components: {
        Proceedings
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
    }
}

</script>

<style lang="css" scoped>
    .image-compass {
        background: transparent url('/images/passer-winkelhaak-4.jpg') no-repeat center -135px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-brothers {
        background: transparent url('/images/masons.jpg') no-repeat center -65px;
        background-size: cover;
        height: 250px;
        position: relative;
        border-bottom: solid 1px #333;
        margin-top: 30px;
    }
</style>
